export const farmacie = [
	{nome: "ALCHEMICA SAS", indirizzo: "C.SO TURATI 74", cap: "10134", email: "farmaciaalchemica@gmail.com"},
	{nome: "ALGOSTINO & DEMICHELIS", indirizzo: "PIAZZA VITTORIO VENETO 10", cap: "10123", email: "ffarmalg@tiscali.it"},
	{nome: "ALMASIO SNC DI CHIASSA", indirizzo: "PIAZZA STATUTO 3", cap: "10122", email: "farmaciaalmasiosnc@yahoo.it"},
	{nome: "ALTHEA", indirizzo: "VIA GORIZIA 133", cap: "10137", email: "farmaciaaltheasnc@gmail.com"},
	{nome: "ANEDDA", indirizzo: "CORSO VITTORIO EMANUELE II  34", cap: "10123", email: "farmacia_anedda@virgilio.it"},
	{nome: "ANGLESIO", indirizzo: "VIA MILANO 11", cap: "10122", email: "farmacia@anglesio.it"},
	{
		nome: "ANTICA FARMACIA BOSIO",
		indirizzo: "VIA GARIBALDI 26",
		cap: "10122",
		email: "gpharma1@anticafarmaciabosio.it"
	},
	{nome: "BAGGIO ROBA", indirizzo: "C.SO TRAIANO 73", cap: "10135", email: "farmacia.baggio-roba@libero.it"},
	{nome: "BAIMA", indirizzo: "PIAZZA RIVOLI 11", cap: "10139", email: "info@farmaciabaima.191.it"},
	{nome: "BALOCCO", indirizzo: "C.SO PESCHIERA 142/F", cap: "10138", email: "farmaciabalocco@gmail.com"},
	{nome: "BEATO ANGELICO", indirizzo: "VIA S.MARINO 69", cap: "10137", email: "farmabeato.asl@libero.it"},
	{nome: "BERNARDI SAS", indirizzo: "VIA DUCHESSA JOLANDA 15/B", cap: "10138", email: "farmaciabernardisas@gmail.com"},
	{nome: "BERTA COLLEGIATA SNC", indirizzo: "VIA PO 51", cap: "10124", email: "farmacia.berta@gmail.com"},
	{
		nome: "BONISCONTRO",
		indirizzo: "C.SO VITTORIO EMANUELE II 66",
		cap: "10121",
		email: "farmaciaboniscontro@libero.it"
	},
	{nome: "BORGARELLI", indirizzo: "VIA MADAMA CRISTINA 62", cap: "10125", email: "farmaciaborgarelli@gmail.com"},
	{nome: "BORGATA LESNA", indirizzo: "VIA MONGINEVRO 245", cap: "10142", email: "farmalesna@libero.it"},
	{nome: "BORGO CRIMEA", indirizzo: "CORSO FIUME 4", cap: "10133", email: "farmaciaborgocrimea@t-web.it"},
	{
		nome: "BORGO CROCETTA",
		indirizzo: "C.SO A.DE GASPERI 6",
		cap: "10129",
		email: "direzione@farmaciaborgocrocettasrl.it"
	},
	{nome: "BORGO PO", indirizzo: "VIA MONFERRATO 22 E", cap: "10131", email: "info@farmaciaborgopo.it"},
	{nome: "BORGO SAN PAOLO", indirizzo: "VIA S.PAOLO 49/A", cap: "10141", email: "farmaciaborgosanpaolo.to@gmail.com"},
	{nome: "BRACCIO", indirizzo: "VIA ALMESE 2/D", cap: "10138", email: "braccio@farmaciesalute.torino.it"},
	{
		nome: "BRAMANTE (EX GUALDI)",
		indirizzo: "C.SO UNIONE SOVIETICA 85",
		cap: "10134",
		email: "farmaciabramante@gmail.com"
	},
	{nome: "BRUNELLESCHI", indirizzo: "C.SO BRUNELLESCHI 75/C", cap: "10141", email: "info@farmaciabrunelleschi.it"},
	{nome: "BULLIO DRANZON", indirizzo: "C.SO RACCONIGI 186", cap: "10141", email: "farmaciabullio@tauservices.com"},
	{nome: "BUSATTI", indirizzo: "VIA MONGINEVRO 57/D", cap: "10141", email: "busatti@farmaciabusatti.it"},
	{nome: "CARLO FELICE", indirizzo: "PIAZZA CARLO FELICE 63", cap: "10123", email: "carlofelice@croceverde.it"},
	{nome: "CAVALLO", indirizzo: "VIA BERTHOLLET 10/A", cap: "10125", email: "farmaciacavallo.to@gmail.com"},
	{nome: "CAVORETTO", indirizzo: "PIAZZA FREGUGLIA 6", cap: "10133", email: "02025@farmapiemonte.org"},
	{nome: "CENISIA", indirizzo: "VIA FREJUS 41", cap: "10139", email: "cenisia@farmaciesalute.torino.it"},
	{nome: "COLLEGIATA SNC", indirizzo: "VIA DEL CARMINE 1", cap: "10122", email: "farmaciacollegiata@gmail.com"},
	{
		nome: "COLLEGIATA SANTA MARIA",
		indirizzo: "VIA S.FRANCESCO D'ASSISI 14",
		cap: "10122",
		email: "farmaciasantamaria@libero.it"
	},
	{nome: "COMUNALE N.1", indirizzo: "C.SO ORBASSANO 249", cap: "10137", email: "farmaciacomunale01@fctorinospa.it"},
	{nome: "COMUNALE N.13", indirizzo: "VIA NEGARVILLE 8/10", cap: "10135", email: "farmaciacomunale13@fctorinospa.it"},
	{nome: "COMUNALE N.15", indirizzo: "C.SO TRAIANO 86", cap: "10135", email: "farmaciacomunale15@fctorinospa.it"},
	{
		nome: "COMUNALE N.17",
		indirizzo: "C.SO V.EMANUELE II 182 BIS/C",
		cap: "10138",
		email: "farmaciacomunale17@fctorinospa.it"
	},
	{
		nome: "COMUNALE N.23",
		indirizzo: "VIA GUIDO RENI 155/157",
		cap: "10148",
		email: "farmaciacomunale23@fctorinospa.it"
	},
	{nome: "COMUNALE N.25", indirizzo: "c/o FF.SS.PORTA NUOVA", cap: "10125", email: "farmaciacomunale25@fctorinospa.it"},
	{nome: "COMUNALE N.28", indirizzo: "C.SO CORSICA 9", cap: "10134", email: "farmaciacomunale28@fctorinospa.it"},
	{nome: "COMUNALE N.35", indirizzo: "VIA CIMABUE 6/O", cap: "10137", email: "farmaciacomunale35@fctorinospa.it"},
	{nome: "COMUNALE N.36", indirizzo: "VIA FILADELFIA 142", cap: "10137", email: "farmaciacomunale36@fctorinospa.it"},
	{nome: "COMUNALE N.37", indirizzo: "C.SO G.AGNELLI 56", cap: "10137", email: "farmaciacomunale37@fctorinospa.it"},
	{nome: "COMUNALE N.38", indirizzo: "VIA VANDALINO 9", cap: "10141", email: "farmaciacomunale38@fctorinospa.it"},
	{nome: "COMUNALE N.40", indirizzo: "VIA FARINELLI 36/9", cap: "10135", email: "farmaciacomunale40@fctorinospa.it"},
	{nome: "COMUNALE N.42", indirizzo: "VIA XX SETTEMBRE 5", cap: "10121", email: "farmaciacomunale42@fctorinospa.it"},
	{nome: "COMUNALE N.43", indirizzo: "P.ZZA STATUTO 4", cap: "10122", email: "farmaciacomunale43@fctorinospa.it"},
	{nome: "COMUNALE N.45", indirizzo: "VIA MONGINEVRO 27/B", cap: "10138", email: "farmaciacomunale45@fctorinospa.it"},
	{nome: "COMUNALE N.46", indirizzo: "P.ZZA C.BOZZOLO 11", cap: "10126", email: "farmaciacomunale46@fctorinospa.it"},
	{nome: "COMUNALE N.5", indirizzo: "VIA RIETI 55", cap: "10142", email: "farmaciacomunale05@fctorinospa.it"},
	{nome: "COMUNALE N.7", indirizzo: "C.SO TRAPANI 150", cap: "10141", email: "farmaciacomunale07@fctorinospa.it"},
	{nome: "COMUNALE N.8", indirizzo: "C.SO TRAIANO 22/E", cap: "10135", email: "farmaciacomunale08@fctorinospa.it"},
	{nome: "COMUNALE N.9", indirizzo: "C.SO SEBASTOPOLI 272", cap: "10136", email: "farmaciacomunale09@fctorinospa.it"},
	{nome: "CORNELIO", indirizzo: "C.SO SIRACUSA 87", cap: "10137", email: "farmacornelio@gmail.com"},
	{nome: "CORSO FRANCIA", indirizzo: "C.SO FRANCIA 175", cap: "10139", email: "farmacia.corsofrancia175@gmail.com"},
	{nome: "CORSO SIRACUSA", indirizzo: "C.SO SIRACUSA 98", cap: "10148", email: "farmcorsosiracusa@libero.it"},
	{nome: "COSENZA", indirizzo: "C.SO COSENZA 39", cap: "10137", email: "farmaciacosenza@gmail.com"},
	{nome: "DANIELE", indirizzo: "C.SO DUCA DEGLI ABRUZZI 66", cap: "10129", email: "farmacia.daniele@tiscali.it"},
	{nome: "DANTE", indirizzo: "C.SO DANTE 78", cap: "10126", email: "info@farmaciadante.it"},
	{nome: "DEGLI STEMMI", indirizzo: "VIA PO 31/B", cap: "10124", email: "farmaciastemmi@gmail.com"},
	{nome: "DEL BENESSERE", indirizzo: "PIAZZA ADRIANO 12", cap: "10138", email: "info@farmaciadelbenessere.com"},
	{nome: "DEL BORGO", indirizzo: "VIA BARLETTA 84/F", cap: "10136", email: "direzioneborgo@gmail.com"},
	{nome: "DEL CONSERVATORIO", indirizzo: "VIA MAZZINI 24", cap: "10123", email: "info@farmaciadelconservatorio.it"},
	{nome: "DEL CORSO", indirizzo: "VIA SALUZZO 1", cap: "10125", email: "info@farmaciadelcorso.to.it"},
	{nome: "DEL GIGLIO", indirizzo: "VIA ARNALDO DA BRESCIA 38", cap: "10134", email: "farmaciadelgiglio@libero.it"},
	{nome: "DEL LEONE", indirizzo: "VIA S.SECONDO 46", cap: "10128", email: "farmaciadelleone@fastwebnet.it"},
	{nome: "DEL MONUMENTO SNC", indirizzo: "C.SO VITTORIO EMANUELE 84", cap: "10121", email: "1422@farmapiemonte.org"},
	{nome: "DELLA CONSOLATA", indirizzo: "VIA DELLE ORFANE 25", cap: "10122", email: "dellaconsolata@libero.it"},
	{nome: "DELLA ROCCA", indirizzo: "VIA DEI MILLE 48", cap: "10123", email: "gabbianoroberto@tiscali.it"},
	{nome: "DELLE ERBE", indirizzo: "VIA RIVALTA 56/D", cap: "10141", email: "farma.mirafiori@gmail.com"},
	{nome: "DELLE MOLINETTE", indirizzo: "VIA NIZZA 183", cap: "10126", email: "farmaciamolinette@gmail.com"},
	{nome: "DELL'ERICA", indirizzo: "VIA DANTE DI NANNI 79/E", cap: "10138", email: "farmaciadellericasnc@gmail.com"},
	{nome: "DELL'ORSO", indirizzo: "VIA BUENOS AIRES 73 BIS", cap: "10137", email: "farmacia@farmaciadellorso.it"},
	{nome: "DELL'UNIVERSITA' GIORDA", indirizzo: "VIA PO 14", cap: "10124", email: "1032@farmapiemonte.org"},
	{nome: "DONATO", indirizzo: "C.SO FRANCIA 385", cap: "10142", email: "info@farmaciadonato.com"},
	{nome: "EUROPA", indirizzo: "C.SO ORBASSANO 302", cap: "10137", email: "ZAPOTT@TISCALI.IT"},
	{nome: "EUROPEA", indirizzo: "VIA MAZZINI 40", cap: "10123", email: "farmaciaeuropeasnc@libero.it"},
	{nome: "FILADELFIA", indirizzo: "VIA GUIDO RENI 109/A", cap: "10137", email: "filadelfia109@gmail.com"},
	{nome: "FREJUS", indirizzo: "C.SO FRANCIA 35", cap: "10138", email: "r.ravazzani@libero.it"},
	{nome: "GALILEO", indirizzo: "LARGO RE UMBERTO 114/A", cap: "10128", email: "farmabivi@libero.it"},
	{nome: "GANCIA-DIMITRI", indirizzo: "VIA ASIAGO 35", cap: "10142", email: "13252@farmapiemonte.org"},
	{nome: "GANI", indirizzo: "VIA NIZZA 108", cap: "10126", email: "farmaciagani@libero.it"},
	{nome: "GAY", indirizzo: "VIA TUNISI 99", cap: "10134", email: "farmacia.gay@libero.it"},
	{nome: "GHEZZO", indirizzo: "VIA PASSO BUOLE 59/H", cap: "10127", email: "farmacia.ghezzo@gmail.com"},
	{nome: "GIACCONE", indirizzo: "VIA BARLETTA 93", cap: "10136", email: "giaccone@farmaciesalute.torino.it"},
	{
		nome: "GIARDINI GUALA s.a.s.",
		indirizzo: "VIA ONORATO VIGLIANI 55/G",
		cap: "10100",
		email: "amministrazione@farmaciagiardiniguala.it"
	},
	{nome: "GILLONE", indirizzo: "VIA MONGINEVRO 105", cap: "10141", email: "farmaciagillone@viamonginevro.net"},
	{nome: "GRAN MADRE", indirizzo: "P.ZZA GRAN MADRE DI DIO 1", cap: "10131", email: "farmgranmadre@gmail.com"},
	{nome: "GRUNER", indirizzo: "VIA SAN TOMMASO 16", cap: "10121", email: "farmaciagruner@virgilio.it"},
	{nome: "GUARINO", indirizzo: "VIA PASSO BUOLE  160/A", cap: "10135", email: "farmaguarino@libero.it"},
	{nome: "I GELSI BORGO PO", indirizzo: "C.SO MONCALIERI 59", cap: "10133", email: "borgopo@farmaciaigelsi.it"},
	{nome: "I PORTICI DI ALM SAS", indirizzo: "VIA NIZZA 15", cap: "10125", email: "farmaciaiportici@gmail.com"},
	{
		nome: "INTERNAZIONALE",
		indirizzo: "VIA CARLO ALBERTO 24",
		cap: "10123",
		email: "farmaciainternazionaletorino@virgilio.it"
	},
	{nome: "LEVA", indirizzo: "CORSO STATI UNITI 5", cap: "10128", email: "amministrazione@farmacialeva.it"},
	{nome: "LINGOTTO", indirizzo: "VIA NIZZA 354", cap: "10127", email: "mail@farmacialingotto.it"},
	{nome: "MADONNA DEGLI ANGELI", indirizzo: "VIA GIOLITTI 7/C", cap: "10123", email: "madonnadegliangelito@libero.it"},
	{nome: "MADONNA DEI FIORI", indirizzo: "C.SO PESCHIERA 244", cap: "10139", email: "madonn2d@farmaciamdf.191.it"},
	{nome: "MADONNA DELL'AIUTO", indirizzo: "VIA TRIPOLI 15", cap: "10136", email: "madonnadellaiuto@libero.it"},
	{
		nome: "MADONNA DELLE ROSE",
		indirizzo: "P.ZZA GALIMBERTI 7",
		cap: "10134",
		email: "farmaciamadonnadellerose@yahoo.it"
	},
	{nome: "MAGNO", indirizzo: "VIA C.COLOMBO 42", cap: "10128", email: "3290@farmapiemonte.org"},
	{nome: "MAMONE", indirizzo: "VIA BELLINI 8", cap: "10121", email: "farmaciamamone@farmaciamamone.it"},
	{nome: "MARIA CRISTINA", indirizzo: "C.SO DE GASPERI 69", cap: "10129", email: "info@farmaciamariacristina.it"},
	{nome: "MASINO", indirizzo: "VIA MARIA VITTORIA 3", cap: "10123", email: "farmacia.masino@libero.it"},
	{
		nome: "MAURIZIANA GSG SNC IELO",
		indirizzo: "C.SO TURATI 38/C",
		cap: "10128",
		email: "farmacia.mauriziana@gmail.com"
	},
	{nome: "MAZZOLI", indirizzo: "C.SO ROSSELLI 106/D", cap: "10129", email: "farmaciaestermazzoli@gmail.com"},
	{nome: "MEDEA", indirizzo: "CORSO UNIONE SOVIETICA 491", cap: "10135", email: "medeafarmacia@gmail.com"},
	{nome: "MILLEFONTI", indirizzo: "VIA NIZZA 249", cap: "10126", email: "millefontifarmacia@gmail.com"},
	{nome: "MINATI", indirizzo: "C.SO SEBASTOPOLI 202/B", cap: "10137", email: "info@farmaciaminati.it"},
	{nome: "MIRAFIORI", indirizzo: "VIA SAN REMO 37", cap: "10137", email: "farma.mirafiori@gmail.com"},
	{nome: "MODERNA", indirizzo: "VIA TRIPOLI 58", cap: "10136", email: "farmamoderna@gmail.com"},
	{nome: "MONARI", indirizzo: "C.SO TRAIANO 158", cap: "10127", email: "info@farmaciamonari.it"},
	{nome: "MONGINEVRO", indirizzo: "VIA MONGINEVRO 178", cap: "10141", email: "livio.oggero@farmapiemonte.org"},
	{nome: "MONTANARO", indirizzo: "C.SO VINZAGLIO 31/E", cap: "10121", email: "farmaciamontanaro@yahoo.com"},
	{nome: "MONVISO", indirizzo: "C.SO GIAMBONE 19", cap: "10134", email: "farmaciamonviso@virgilio.it"},
	{nome: "NIZZA SAS", indirizzo: "VIA NIZZA 65", cap: "10125", email: "farmanizza.to@gmail.com"},
	{nome: "OPERTI", indirizzo: "P.ZZA VITTORIO VENETO 11", cap: "10124", email: "farmaciaoperti@gmail.com"},
	{
		nome: "ORDINE MAURIZIANO",
		indirizzo: "PIAZZA DELLA REPUBBLICA 6/B",
		cap: "10122",
		email: "farmaciaordinemauriziano@gmail.com"
	},
	
	{nome: "OTTONE", indirizzo: "C.SO U. SOVIETICA 491", cap: "10135", email: "farmacia_ottone@libero.it"},
	{nome: "PARINI", indirizzo: "VIA DE SANCTIS 60", cap: "10142", email: "farmaciaparinisnc@gmail.com"},
	{nome: "PENSA", indirizzo: "VIA CERNAIA 14/A", cap: "10122", email: "cristiana@farmaciapensa.it"},
	{nome: "PESCHIERA", indirizzo: "C.SO PESCHIERA 295", cap: "10141", email: "13134@farmapiemonte.org"},
	{nome: "PIAZZA MASSAUA", indirizzo: "PIAZZA MASSAUA 1", cap: "10141", email: "farmaciamassaua@gmail.com"},
	{nome: "PICCO", indirizzo: "VIA SACCHI 46", cap: "10128", email: "1021@farmapiemonte.org"},
	{nome: "PILONETTO SAS", indirizzo: "C.SO MONCALIERI 265", cap: "10133", email: "22116@farmapiemonte.org"},
	{nome: "PIAZZA PITAGORA", indirizzo: "PIAZZA PITAGORA 9", cap: "10137", email: "12176@farmapiemonte.org"},
	{nome: "PO", indirizzo: "VIA PO 4", cap: "10123", email: "farmaciaviapo@virgilio.it"},
	{nome: "PORTA NUOVA", indirizzo: "VIA SACCHI 4", cap: "10128", email: "info@farmaciaportanuova.it"},
	{nome: "PORTA SUSA", indirizzo: "C.SO FRANCIA 1/BIS", cap: "10138", email: "farmasusa@gmail.com"},
	{nome: "PORTIS", indirizzo: "VIA MADAMA CRISTINA 37", cap: "10125", email: "farmaciaportis@gmail.com"},
	{nome: "ANNUNZIATA", indirizzo: "VIA STRADELLA 198", cap: "10147", email: "info@farmacia-annunziata.com"},
	{nome: "AURORA SNC", indirizzo: "C.SO G. CESARE, 24", cap: "10152", email: "farbevi@farmaciaaurora.com"},
	{nome: "BALOSSINO", indirizzo: "STR. SAN MAURO, 179", cap: "10156", email: "farmaciabalossino@plion.it"},
	{nome: "BOCCACCIO", indirizzo: "VIA BOCCACCIO, 16/A", cap: "10132", email: "info@farmaciaboccacciotorino.com"},
	{nome: "BONANNO", indirizzo: "C.SO R. MARGHERITA 254/c", cap: "10144", email: "farmaregina256@alice.it"},
	{nome: "BORELLI", indirizzo: "VIA S. DONATO 9", cap: "10144", email: "farmaciaborelli@libero.it"},
	{nome: "BORGO ROSSINI", indirizzo: "VIA REGGIO, 1", cap: "10153", email: "farmaciarossini@virgilio.it"},
	{
		nome: "BORGO VITTORIA SNC",
		indirizzo: "VIA CHIESA DELLA SALUTE 64",
		cap: "10147",
		email: "amministrazione@borgo-vittoria.it"
	},
	{nome: "BREGLIO SNC", indirizzo: "VIA BREGLIO 16", cap: "10147", email: "breglio@farmaciesalute.torino.it"},
	{nome: "CALANDRA SNC", indirizzo: "VIA CRESCENTINO, 34", cap: "10154", email: "farm.calandra@libero.it"},
	{nome: "CALVO", indirizzo: "VIA B. LUINI 34", cap: "10149", email: "farmaciacalvo@libero.it"},
	{nome: "CARUSO", indirizzo: "C.SO BELGIO, 180", cap: "10153", email: "skcaruso@tin.it"},
	{nome: "CASTALDI", indirizzo: "P.ZZA CAMPANELLA 3", cap: "10146", email: "farmacia.castaldi@libero.it"},
	{nome: "CERVINO", indirizzo: "C.SO VERCELLI, 111", cap: "10155", email: "farmaciacervino@libero.it"},
	{nome: "CESANO", indirizzo: "VIA BOLOGNA, 250/A", cap: "10154", email: "farcesano@virgilio.it"},
	{nome: "CHIERICI", indirizzo: "VIA CHIESA DELLA SALUTE 105", cap: "10147", email: "farmaciachierici@libero.it"},
	{nome: "CIGNA SAS", indirizzo: "VIA CIGNA, 53", cap: "10152", email: "info@farmaciacigna.it"},
	{nome: "COMUNALE 02", indirizzo: "VIA SLATAPER 25/BIS", cap: "10149", email: "farmaciacomunale02@fctorinospa.it"},
	{nome: "COMUNALE 04", indirizzo: "VIA OROPA, 69", cap: "10153", email: "farmaciacomunale04@fctorinospa.it"},
	{
		nome: "COMUNALE 10",
		indirizzo: "VIA ASINARI DI BERNEZZO 134",
		cap: "10146",
		email: "farmaciacomunale10@fctorinospa.it"
	},
	{nome: "COMUNALE 11", indirizzo: "PIAZZA STAMPALIA 7/b", cap: "10148", email: "farmaciacomunale11@fctorinospa.it"},
	{nome: "COMUNALE 12", indirizzo: "C.SO VERCELLI, 236", cap: "10155", email: "farmaciacomunale12@fctorinospa.it"},
	{nome: "COMUNALE 19", indirizzo: "VIA VIBO' 17/B", cap: "10147", email: "farmaciacomunale19@fctorinospa.it"},
	{nome: "COMUNALE 20", indirizzo: "C.SO ROMANIA 460", cap: "10156", email: "farmaciacomunale20@fctorinospa.it"},
	{nome: "COMUNALE 21", indirizzo: "C.SO BELGIO, 151/B", cap: "10153", email: "farmaciacomunale21@fctorinospa.it"},
	{nome: "COMUNALE 22", indirizzo: "VIA CARLO CAPELLI 47", cap: "10146", email: "farmaciacomunale22@fctorinospa.it"},
	{nome: "COMUNALE 24", indirizzo: "CORSO TELESIO 27/B", cap: "10146", email: "farmaciacomunale24@fctorinospa.it"},
	{nome: "COMUNALE 29", indirizzo: "VIA ORVIETO 10/A", cap: "10149", email: "farmaciacomunale29@fctorinospa.it"},
	{nome: "COMUNALE 33", indirizzo: "VIA ISERNIA 13 B", cap: "10151", email: "farmaciacomunale33@fctorinospa.it"},
	{nome: "COMUNALE 41", indirizzo: "VIA DEGLI ABETI, 10/U", cap: "10156", email: "farmaciacomunale41@fctorinospa.it"},
	{nome: "COMUNALE 44", indirizzo: "VIA CIBRARIO 72", cap: "10144", email: "farmaciacomunale44@fctorinospa.it"},
	{nome: "CORSO GROSSETO", indirizzo: "C.SO GROSSETO 221", cap: "10147", email: "art.grosseto@alice.it"},
	{nome: "CORSO REGINA SNC", indirizzo: "C.SO R. MARGHERITA, 72", cap: "10153", email: "info@farmaciacorsoregina.it"},
	{nome: "CRIDA", indirizzo: "VIA CIBRARIO 88", cap: "10143", email: "jeffa15@hotmail.com"},
	{nome: "DE ANGELI", indirizzo: "VIA BOLOGNA 21", cap: "10152", email: "farmaciadeangel1979@libero.it"},
	{nome: "DEI FIORI SNC", indirizzo: "C.SO REGIO PARCO 38", cap: "10152", email: "7221@farmapiemonte.org"},
	{nome: "DEL MERCATO SNC", indirizzo: "C.SO GROSSETO 216/C", cap: "10148", email: "direzione@farmaciadelmercato.com"},
	{nome: "DELLA MOLE SAS", indirizzo: "C.SO S. MAURIZIO, 35/D", cap: "10124", email: "farmaciadellamole@gmail.com"},
	{nome: "DELLA STURA SAS", indirizzo: "VIALE FALCHERA 70/D", cap: "10156", email: "info@farmaciadellastura.it"},
	{nome: "DELL'AUSILIATRICE SNC", indirizzo: "C.SO P. ODDONE, 28", cap: "10152", email: "info@farmaciaausiliatrice.it"},
	{nome: "DELLE MADDALENE SNC", indirizzo: "P.ZZA RESPIGHI, 3", cap: "10154", email: "dellemaddalene@yahoo.it"},
	{nome: "DELLE VALLETTE SNC", indirizzo: "V.LE DEI MUGHETTI 9/E", cap: "10151", email: "15025@farmapiemonte.org"},
	{
		nome: "ANTICA FARMACIA DELLA VIGNA - DON BOSCO",
		indirizzo: "VIA CIGNA, 38/E",
		cap: "10152",
		email: "farmaciadonboscotorino@gmail.com"
	},
	{nome: "DORA", indirizzo: "VIA CIGNA 118", cap: "10155", email: "7125@farmapiemonte.org"},
	{nome: "DUTTO SNC", indirizzo: "C.SO G. CESARE, 48", cap: "10152", email: "farmaciadutto@libero.it"},
	{nome: "FRANCO SAS", indirizzo: "VIA OXILIA, 13", cap: "10155", email: "19095@farmapiemonte.org"},
	{nome: "GARELLI SNC", indirizzo: "VIA CARDINAL MASSAIA 45", cap: "10147", email: "15028@farmapiemonte.org"},
	{nome: "GLI SPEZIALI SRL", indirizzo: "PIAZZA CRISPI, 60", cap: "10155", email: "info@farmaciaglispeziali.com"},
	{nome: "GOTTARDO SAS", indirizzo: "L.GO SEMPIONE, 186/C", cap: "10155", email: "gottardo1@libero.it"},
	{nome: "GRANERO SNC", indirizzo: "VIA BRANDIZZO, 90", cap: "10154", email: "GRANER00@farmaciagranero.191.it"},
	{nome: "IGEA SNC", indirizzo: "L.GO TOSCANA 50", cap: "10149", email: "igea@plugit.net"},
	{nome: "LUCENTE", indirizzo: "VIA CARRERA 88", cap: "10146", email: "lucente.farmacia@gmail.com"},
	{nome: "LUCENTO", indirizzo: "VIA OGLIANICO 4", cap: "10149", email: "farmacialucento@tauservices.com"},
	{nome: "MADONNA DEL PILONE SNC", indirizzo: "C.SO CASALE, 110", cap: "10132", email: "farmamdp2@gmail.com"},
	{nome: "MADONNA DELLA PACE", indirizzo: "C.SO PALERMO, 119", cap: "10154", email: "farmabollo@inwind.it"},
	{nome: "MADONNA DELLA SALUTE", indirizzo: "P.ZZA DELLA VITTORIA 29", cap: "10147", email: "15038@farmapiemonte.org"},
	{nome: "MADONNA DI CAMPAGNA", indirizzo: "C.SO GROSSETO 256", cap: "10148", email: "ferraris.l@libero.it"},
	{nome: "MANENTI", indirizzo: "VIA PIFFETTI 31 BIS", cap: "10143", email: "farmaciamanenti@gmail.com"},
	{nome: "MARINELLO DI MAGISTRA SRL", indirizzo: "C.SO BELGIO, 97", cap: "10153", email: "info@farmaciamarinello.it"},
	{nome: "MINERVA SAS", indirizzo: "V.LE DEI MUGHETTI 1", cap: "10151", email: "farmaciaminervatorino@gmail.com"},
	{nome: "MONGE", indirizzo: "C.SO R. MARGHERITA 218 BIS", cap: "10144", email: "mongefarm@tin.it"},
	{nome: "MONTEGRAPPA SAS", indirizzo: "CORSO MONTE GRAPPA 55 D", cap: "10146", email: "farmamontegrappa@gmail.com"},
	{nome: "MONTEROSA SNC", indirizzo: "C.SO GIULIO CESARE, 158", cap: "10154", email: "farmamonterosa@alice.it"},
	{nome: "NAZIONALE SNC", indirizzo: "VIA VANCHIGLIA, 29/A", cap: "10124", email: "farm.nazionale@libero.it"},
	{nome: "NOVARA", indirizzo: "VIA  ANCINA 43/G", cap: "10154", email: "farmanovara@gmail.com"},
	{
		nome: "OMEOPATICA DABBENE SRL",
		indirizzo: "VIA BOLOGNA, 91/D",
		cap: "10154",
		email: "amministrazione@farmaciadabbene.it"
	},
	{nome: "PALATINA", indirizzo: "C.SO R. MARGHERITA, 134 M", cap: "10152", email: "palatinatorino@gmail.com"},
	{nome: "PARELLA SRL", indirizzo: "VIA C. CAPELLI 67", cap: "10146", email: "farmaciaparellasrl@libero.it"},
	{nome: "PIAZZA VILLARI", indirizzo: "VIA FOLIGNO 69", cap: "10149", email: "info@farmaciapiazzavillari.com"},
	{nome: "PICCARDO", indirizzo: "VIA DELLE VERBENE 11", cap: "10151", email: "farmaciapiccardo@libero.it"},
	{nome: "PIEMONTE SRL", indirizzo: "C.SO TOSCANA 107", cap: "10149", email: "farmaciapiemonte@gmail.com"},
	{nome: "PIETRO COSSA", indirizzo: "VIA P. COSSA 106", cap: "10146", email: "farmaciapietrocossa@gmail.com"},
	{nome: "POLICLINICO Sas", indirizzo: "VIA SEMPIONE, 112", cap: "10155", email: "edoardo.toia@farmaciapoliclinico.it"},
	{nome: "PORINELLI", indirizzo: "C.SO SAN MAURIZIO, 67", cap: "10124", email: "8164@farmapiemonte.org"},
	{nome: "PORPORA SNC", indirizzo: "VIA N. PORPORA, 27", cap: "10155", email: "mail@farmaciaporpora.it"},
	{
		nome: "PORTA PALAZZO SAS",
		indirizzo: "PIAZZA DELLA REPUBBLICA, 21",
		cap: "10152",
		email: "farmaciap.palazzo@libero.it"
	},
	{nome: "Prof. CAVANNA SNC", indirizzo: "VIA MOSCA 1", cap: "10147", email: "farmaciacavanna@gmail.com"},
	{nome: "REGINA MARGHERITA", indirizzo: "C.SO REGINA MARGHERITA 440", cap: "10151", email: "17150@farmapiemonte.org"},
	{nome: "REGIO PARCO", indirizzo: "C.SO TARANTO, 183/C", cap: "10154", email: "diegoporta73@libero.it"},
	{nome: "RINETTI", indirizzo: "C.SO LECCE 31", cap: "10145", email: "farmacia.rinetti@libero.it"},
	{nome: "ROBINO", indirizzo: "VIA PALESTRINA, 49", cap: "10155", email: "FARMACIAROBINO@libero.it"},
	{
		nome: "S. ANGELI CUSTODI SNC",
		indirizzo: "C.SO VERCELLI, 195",
		cap: "10155",
		email: "santiangelicustodi@tiscali.it"
	},
	{nome: "SAN DONATO", indirizzo: "VIA S. DONATO 55", cap: "10144", email: "informazioni@farmaciasandonato.it"},
	{nome: "SAN MICHELE", indirizzo: "C.SO TARANTO, 15", cap: "10154", email: "farmaciasanmichele@virgilio.it"},
	{nome: "SAN PAOLO SAS", indirizzo: "VIA BERRINO 6", cap: "10148", email: "farmaciasanpaolo2010@gmail.com"},
	{nome: "SAN ROCCO", indirizzo: "C.SO GROSSETO 165", cap: "10147", email: "farmaciasanrocco.ag@gmail.com"},
	{nome: "SANSOVINO", indirizzo: "C.SO TOSCANA 185/A", cap: "10151", email: "farmaciasansovino@libero.it"},
	{nome: "SANTA CHIARA", indirizzo: "VIA BORGARO 103", cap: "10149", email: "farmasantachiara2016@libero.it"},
	{nome: "SANTA CROCE", indirizzo: "C.SO CASALE, 204", cap: "10132", email: "farmaciasantacrocetorino@gmail.com "},
	{nome: "SANTA ELISABETTA", indirizzo: "C.SO GROSSETO 66", cap: "10148", email: "farmaciasantaelisabetta@gmail.com"},
	{nome: "SANTA GIULIA SNC", indirizzo: "VIA SANTA GIULIA, 38", cap: "10124", email: "8142@farmapiemonte.org"},
	{nome: "SANTA GIUSTINA", indirizzo: "C.SO REGINA MARGHERITA 114", cap: "10152", email: "jofarm@libero.it"},
	{nome: "SANTA MARTA", indirizzo: "VIA N. FABRIZI 102", cap: "10145", email: "amministrazione@farmaciasantamarta.it"},
	{nome: "SANTA TERESA SNC", indirizzo: "VIA BORSI 114", cap: "10149", email: "steresa.farma@gmail.com"},
	{nome: "SANTA ZITA SAS", indirizzo: "VIA CIBRARIO 33 BIS", cap: "10143", email: "farmaciasantazita@gmail.com"},
	{nome: "SANT'AGNESE", indirizzo: "STRADA SAN MAURO, 35", cap: "10156", email: "farmaciasantagnese@gmail.com"},
	{nome: "SANT'ALFONSO", indirizzo: "C.SO TASSONI 66/D", cap: "10144", email: "farmaciasantalfonso@gmail.com"},
	{nome: "SARDI", indirizzo: "VIA BORGARO 58", cap: "10149", email: "mauriziosardi@farmaciasardi.it"},
	{nome: "SASSI", indirizzo: "C.SO CASALE, 316", cap: "10132", email: "farmaciasassi@tauservices.com"},
	{nome: "SCOTTI SAS", indirizzo: "VIA NICOLA FABRIZI 11", cap: "10143", email: "farmasco@fastwebnet.it"},
	{nome: "SEMPIONE SAS", indirizzo: "C.SO G. CESARE, 118", cap: "10154", email: "20090@farmapiemonte.org"},
	{nome: "SERRAVALLE SAS", indirizzo: "VIA M. LESSONA 29", cap: "10145", email: "Farmaciaserravalle@libero.it"},
	{nome: "STRADELLA", indirizzo: "VIA STRADELLA 36", cap: "10147", email: "farmaciastradella@gmail.com"},
	{nome: "SQUILLARIO", indirizzo: "C.SO BELGIO, 41", cap: "10153", email: "squillo82@gmail.com"},
	{nome: "STROPPIANA", indirizzo: "C.SO SVIZZERA 42", cap: "10143", email: "farmaciastroppiana@libero.it"},
	{nome: "SUBALPINA", indirizzo: "VIA CASTELNUOVO, 5", cap: "10132", email: "farmacia.subalpina@gmail.com"},
	{nome: "TESORIERA SRL", indirizzo: "C.SO FRANCIA 212", cap: "10146", email: "14125@farmapiemonte.org"},
	{nome: "TOSCANA", indirizzo: "CORSO TOSCANA 20", cap: "10149", email: "farmatosca@gmail.com"},
	{nome: "VELA", indirizzo: "C.SO POTENZA 92", cap: "10149", email: "info@farmaciavela.it"},
]
